/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from "../../../components/Modal";
import Button from "../../../components/Button";
import DataComponent from '../../../components/DataComponent';
import DeleteIcon from "../../../assets/images/icon/delete-icon.svg";
import DeleteIcon01 from "../../../assets/images/icon/delete-icon-01.svg";
import EditButton from "../../../assets/images/icon/edit-btn.svg";
import IconButton from "../../../components/Button/IconButton";
import { getDay } from '../../../utils/date';
import {
  createBanksCashAccountsTransList,
  deleteBanksTransClients,
  getBankTransRecordDetail,
  modifyBanksCashAccountsTransList
} from '../../../apis/finances/bank';
import { forEach, isEmpty } from 'lodash';
import systemAlert from '../../../utils/systemAlert';
import { restoreComma, transformComma } from '../../../utils/validator/comma';
import DetailBody from '../AccountDetail/DetailBody';
import { viewLoading } from '../../../utils/loading';
import { preventEvent } from '../../../utils/element';
import { classnames } from '../../../utils/text';
import Icon from '../../../components/Icon';
import Comment from '../../../components/Comment';
import { clientPreview } from '../../../utils/client';
import CategoryMappingModal from '../../../components/Bank/CategoryMappingModal';
import ClientMappingModal from '../../../components/Bank/ClientMappingModal';
import { deleteAccountingTitle } from '../../../apis/finances/accounting-title';
import SearchClientModal from '../../../components/Bank/SearchClientModal';

const CashAccountTransaction = ({
  open,
  setOpen,
  bankData,
  submit,
  listSubmit,
  formData,
  setFormData,
  permission,
}) => {
  const [fields, setFields] = useState([]);
  const [formValues, setFormValues] = useState([
    {
      tradeTime: getDay(),
      inAmt: '',
      outAmt: '',
      remark: '',
      detail: '',
    }
  ]);
  const [mode, setMode] = useState('create');
  const [data, setData] = useState({});
  const [selectedList, setSelectedList] = useState([]);
  // 거래처 매핑
  const [isClientMappingOpen, setIsClientMappingOpen] = useState(false);
  // 카테고리 매핑
  const [isCategoryMappingOpen, setIsCategoryMappingOpen] = useState(false);

  const [selectIdx, setSelectIdx] = useState(null);

  const handleRemoveClient = (data, client) => {
    const bankIdx = data.idx;
    const clientIdx = client.idx;

    systemAlert(`은행내역에 매핑된 거래처(${client.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            if (mode === "modify") {
              deleteBanksTransClients(bankIdx, clientIdx)
                .then(() => {
                  _submit();
                })
                .catch(() => { })
                .finally(() => { });
            } else if (mode === "create") {
              const tableIdx = data.tableIdx;

              data = {
                ...data,
                clients: data.clients?.filter(f => f.idx !== clientIdx)
              };
              formValues[tableIdx] = data;
              setFormValues(formValues);
            }
          }
        }
      ]
    });
  };

  const handleRemoveCategory = (category, data) => {
    systemAlert(`은행내역에 매핑된 카테고리(${category.accountingTitle.name})를 삭제하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            if (mode === "modify") {
              deleteAccountingTitle(category.idx)
                .then(() => {
                  _submit();
                })
                .catch(() => { })
                .finally(() => { });
            } else if (mode === "create") {
              const categoryIdx = category?.accountingTitle?.idx;
              const tableIdx = data.tableIdx;
              data = {
                ...data,
                accountingTitleUses: (data.accountingTitleUses || []).filter(item => item?.accountingTitle?.idx !== categoryIdx)
              };
              formValues[tableIdx] = data;
              setFormValues(formValues);
            }
          }
        }
      ]
    });
  };

  useEffect(() => {
    setFields([
      {
        title: '거래일시',
        key: 'tradeTime',
        type: 'datetimepicker',
        disabled: mode === 'modify'
      },
      {
        title: '입금액',
        key: 'inAmt',
        type: 'input',
        className: 'color-red-100'
      },
      {
        title: '출금액',
        key: 'outAmt',
        type: 'input',
        className: 'color-purple-100'
      },
      {
        title: '적요',
        key: 'remark',
        type: 'input'
      },
      {
        title: "거래처",
        key: "clients",
        className: "text-align-right",
        onValue: (value, field, data) => {
          return (
            !isEmpty(value) &&
            value.map((client, idx) => (
              <p className="pt-8 pb-8" key={idx}>
                <span className="vertical-middle cursor-pointer"
                  onClick={(e) => {
                    preventEvent(e);
                    client.companyAccount && clientPreview(client.companyAccount.idx);
                  }}>{client.name}
                </span>
                {permission.level > 1 && (
                  <IconButton className="ml-4 vertical-middle"
                    icon={DeleteIcon01}
                    action={() => handleRemoveClient(data, client, idx)}
                  />)}
              </p>
            ))
          );
        }
      },
      {
        title: '카테고리',
        key: 'accountingTitleUses',
        className: "text-align-right",
        onValue: (value, _f, data) => {
          return (
            !isEmpty(value) &&
            value.map((category, idx) => (
              <p className="pt-8 pb-8" key={idx}>
                <span className="vertical-middle">
                  {category?.accountingTitle?.name}
                </span>
                {permission.level > 1 && (
                  <IconButton className="ml-4 vertical-middle"
                    icon={DeleteIcon01}
                    action={() => handleRemoveCategory(category, data)}
                  />)}
              </p>
            ))
          );
        }
      },
    ]);
  }, [formValues, mode]);
  useEffect(() => {
    setMode(isEmpty(formData) ? 'create' : 'modify');
  }, [open, formData]);

  useEffect(() => {
    !isEmpty(formData) && _submit();
  }, [open, formData, mode]);


  useEffect(() => {
    if (!isEmpty(data)) {
      setFormValues([
        {
          ...data,
          tradeTime: data.tradeTime,
          inAmt: transformComma(data.inAmt),
          outAmt: transformComma(data.outAmt),
          remark: data.remark,
        }
      ]);
    }
  }, [data]);

  const cancel = () => {
    setOpen(false);
    setMode('create');
    setFormValues([
      {
        tradeTime: getDay(),
        inAmt: '',
        outAmt: '',
        remark: '',
      }
    ]);
    setData({});
    setFormData({});
  };

  const handleAddRow = () => {
    setFormValues(oldVal => [...oldVal, { tradeTime: getDay(), inAmt: '', outAmt: '', remark: '' }]);
  };

  const handleOnChange = (e, idx, type) => {
    let values = [...formValues];
    let newValue = {
      ...values[idx],
      tableIdx: idx
    };

    if (type === 'datetimepicker') {
      newValue = {
        ...newValue,
        tradeTime: e.tradeTime.toString()
      };
      values[idx] = newValue;
      setFormValues(values);
    }

    if (type === 'input' || type === 'number') {
      const { name, value } = e.target;
      if (name === 'inAmt') {
        newValue = {
          ...newValue,
          inAmt: transformComma(value),
          outAmt: "0"
        };
      }

      if (name === 'outAmt') {
        newValue = {
          ...newValue,
          inAmt: "0",
          outAmt: transformComma(value),
        };
      }

      if (name === 'remark') {
        newValue = {
          ...newValue,
          [name]: value
        };
      }

      values[idx] = newValue;
      setFormValues(values);
    }
  };

  const handleOnRemoveItem = (idx) => {
    setFormValues(() => [
      ...formValues.filter((values, valueIndex) => valueIndex !== idx),
    ]);
  };

  const handleSumit = () => {
    if (mode === 'create') {
      const body = {
        transList: formValues.map((values) => ({
          ...values,
          tradeTime: values.tradeTime + ":00",
          inAmt: restoreComma(values.inAmt),
          outAmt: restoreComma(values.outAmt),
          accountingTitleUses: (values.accountingTitleUses || []).map(item => {
            return item.accountingTitle;
          })
        })),
      };

      systemAlert('해당 기타거래에 거래내역을 등록하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '추가',
            onClick: () => {
              createBanksCashAccountsTransList(bankData.accountNo, body)
                .then((res) => {
                  submit();
                  listSubmit();
                  cancel();
                });
            }
          }
        ]
      });
    }

    if (mode === 'modify') {
      const body = {
        remark: formValues[0].remark || "",
        tradeTime: formValues[0].tradeTime + ":00",
        inAmt: restoreComma(formValues[0].inAmt),
        outAmt: restoreComma(formValues[0].outAmt),
      };

      systemAlert('해당 거래내역을 수정하시겠습니까?', {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              modifyBanksCashAccountsTransList(bankData.accountNo, formData.idx, body).then((res) => {
                submit();
                listSubmit();
                cancel();
              });
            }
          }
        ]
      });
    }
  };

  const getDisabled = () => {
    let disabled = false;

    forEach(formValues, (values) => {
      if (
        isEmpty(values.tradeTime) ||
        isEmpty(values.inAmt) ||
        isEmpty(values.outAmt)
      ) {
        disabled = true;
      }
    });

    return disabled;
  };

  const _submit = () => {
    if (mode === "modify") {
      viewLoading(true);
      getBankTransRecordDetail(formData.idx).then((res) => {
        res.data = {
          ...res.data,
          inAmt: String(res.data.inAmt),
          outAmt: String(res.data.outAmt)
        };
        setData(res.data);

      }).finally(() => viewLoading(false));
    }
  };

  const totalSubmit = () => {
    _submit();
    listSubmit();
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="cash-account-transaction-modal">
        <div className="modal-header-wrap">
          <ModalHeader>{bankData.name} 거래내역 {mode === 'create' ? '추가' : '수정'}</ModalHeader>
          {mode === 'create' && <Button className="add-trans-button" color="line" label="행 추가" onClick={handleAddRow} />}
        </div>
        <p className="cash-account-transaction-description">
          입금내역과 출금내역은 별도로 작성해주세요.
        </p>
        <table className="cash-account-transaction-table">
          <colgroup>
            <col width="200px"></col>
            <col width="100px"></col>
            <col width="100px"></col>
            <col width="150px"></col>
            <col width="200px"></col>
            <col width="200px"></col>
            <col width="175px"></col>
          </colgroup>
          <thead>
            <tr>
              {fields.map((field, idx) => (
                <th key={idx}>{field.title}</th>
              ))}
              {<th>거래처 매핑 / 카테고리 매핑</th>}

              <th></th>
            </tr>
          </thead>
          <tbody>
            {formValues.map((_value, idx) => (
              <tr key={idx}>
                {fields.map((_field, index) => (
                  <td key={index}>
                    <DataComponent
                      className={_field.className}
                      field={_field}
                      onChange={(e) => handleOnChange(e, idx, _field.type)}
                      form={_value}
                      defaultValue={_field.defaultValue}
                    />
                  </td>
                ))}
                {(
                  <td className="row-btn-td">
                    <button
                      className={classnames(
                        "icon-button",
                        "mr-4",
                      )}
                      type="button"
                      onClick={(e) => {
                        preventEvent(e);
                        setSelectedList([data]);
                        setIsClientMappingOpen(true);
                        mode === "create" && setSelectIdx(idx);
                      }}
                    >
                      <Icon src={EditButton} />
                    </button>
                    <button
                      className={classnames(
                        "icon-button",
                        "ml-4",
                      )}
                      type="button"
                      onClick={(e) => {
                        preventEvent(e);
                        setSelectedList([data]);
                        setIsCategoryMappingOpen(true);
                        mode === "create" && setSelectIdx(idx);
                      }}
                    >
                      <Icon src={EditButton} />
                    </button>
                  </td>
                )}
                <td>
                  {formValues.length > 1 && (
                    <IconButton
                      icon={DeleteIcon}
                      className="delete-btn"
                      onClick={() => handleOnRemoveItem(idx)}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {mode === "modify" && (
          <DetailBody
            formData={data}
            permission={permission}
            submit={_submit}
            totalSubmit={totalSubmit}
            open={open}
          />
        )}
        {mode === "modify" && (
          <div className="margin-top-24">
            <Comment
              postIdx={formData.idx}
              postType="bank_trans"
              submit={listSubmit}
            />
          </div>
        )}
        <div className="control-button-wrap">
          <Button className="button" label={mode === "modify" ? "수정" : "등록"} onClick={handleSumit} disabled={getDisabled()} />
          <Button className="button" color="text" label="취소" onClick={cancel} />
        </div>
      </div>
      {isClientMappingOpen && !isEmpty(selectedList) && mode === "modify" && (
        <ClientMappingModal
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          selected={selectedList}
          setSelected={setSelectedList}
          submit={() => _submit()}
        />
      )}
      {isClientMappingOpen && !isEmpty(selectedList) && mode === "create" && (
        <SearchClientModal
          open={isClientMappingOpen}
          setOpen={setIsClientMappingOpen}
          selected={formValues.map((values, idx) => ({
            ...values,
            idx,
            addClients: values.clients || []
          }))}
          bankTransIdx={selectIdx}
          setSelected={(data) => {
            setFormValues(data.map(item => (
              {
                tableIdx: item.tableIdx,
                detail: item.detail,
                inAmt: item.inAmt,
                outAmt: item.outAmt,
                remark: item.remark,
                tradeTime: item.tradeTime,
                clients: item.addClients,
                accountingTitleUses: item.accountingTitleUses,
              }
            )));
          }}
        />
      )}


      {isCategoryMappingOpen && !isEmpty(selectedList) && (
        <CategoryMappingModal
          open={isCategoryMappingOpen}
          setOpen={setIsCategoryMappingOpen}
          selectedItem={mode === "create" ? formValues.map((values, idx) => ({
            ...values,
            idx,
            addClients: values.clients || []
          })) : selectedList}
          setSelectedItem={mode === "create" ? (data) => {
            setSelectIdx(null);
            setFormValues(data.map(item => (
              {
                tableIdx: item.tableIdx,
                detail: item.detail,
                inAmt: item.inAmt,
                outAmt: item.outAmt,
                remark: item.remark,
                tradeTime: item.tradeTime,
                clients: item.addClients,
                accountingTitleUses: item.accountingTitleUses,
              }
            )));
          } : setSelectedList}
          selectIdx={selectIdx}
          useType="bank_trans"
          submit={() => _submit()}
          mode={mode}
        />
      )}
    </Modal>
  );
};

export default CashAccountTransaction;